import React, { useEffect, useState } from "react";
import Flex from "../../../../structure/Flex";
import Input from "../Input";
import MultiSelect from "../MultiSelect";

type MultiSelectOrTextValue = { selected: any[]; text: string };

interface MultiSelectOrTextProps {
  options?: Array<{ id: any; value: string; hint?: any }>;
  value: MultiSelectOrTextValue;
  name: string;
  setValue: React.Dispatch<MultiSelectOrTextValue>;
  placeholder?: string;
}

const MultiSelectOrText: React.FC<MultiSelectOrTextProps> = ({
  options = [],
  value,
  setValue,
  name,
  placeholder,
}) => {
  const [selected, setSelected] = useState<any[]>(value.selected || []);
  const [text, setText] = useState(value.text || "");

  useEffect(() => {
    setValue({ selected, text });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, text]);

  return (
    <Flex className="p-2 w-full" justify="between" items="center">
      <span className="flex flex-wrap flex-grow">
        <MultiSelect
          name={`${name}-options-select`}
          value={selected}
          setValue={setSelected}
          options={options}
        />
      </span>
      <span className="mx-6">or</span>
      <span className="flex-grow">
        <Input
          type="text"
          name={`${name}-custom-text`}
          placeholder="Enter your own"
          value={text}
          setValue={setText}
        />
      </span>
    </Flex>
  );
};

export default MultiSelectOrText;
